  <template>
    <div style="background:white; height:100%">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:90px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px; ">新增 </span></el-link>
                </div>
                <span style="  font-size:12px;margin-right:10px;margin-left:5px">字段查询</span>
                <el-select @change="selChg" v-model="selparam" size="small" placeholder="请选择列名" filterable  style="width:130px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :disabled="item.key=='adddttm'" :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input v-if="v_bool" :placeholder="input_hold" clearable v-model="txtparam" @keyup.enter.native="inputQry" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px;background:white;border:1px solid #389 " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <template slot ="append">
                        <el-button size="small" slot="append" icon="iconfont icon-gaojichazhao2" @click="inputQry" class="custom-button" ></el-button>
                    </template>
                </el-input> 
                <el-date-picker @change="inputQry" style="width:300px" size="small" value-format="yyyy-MM-dd" v-if="!v_bool"  v-model="txtArr1" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期">  </el-date-picker>
                <!-- <el-select @change="selChg2" v-model="selparam2" size="small" placeholder="请选择列名"  filterable style="width:130px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :disabled="item.key=='adddttm'" :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input v-if="v_bool2" :placeholder="input_hold" clearable v-model="txtparam2" @keyup.enter.native="inputQry" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px;background:white;border:1px solid #389  " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="iconfont icon-gaojichazhao2" @click="inputQry" class="custom-button"></el-button>
                </el-input>
                <el-date-picker @change="inputQry" style="width:300px" size="small" value-format="yyyy-MM-dd" v-if="!v_bool2"  v-model="txtArr2" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期">  </el-date-picker> -->
                <el-button @click="freshCalc"  size="mini" type="primary" style=" height:31px;margin-left:15px;fon-size:12px "><i class= "iconfont icon-xitongguanli"></i>余额计算</el-button>
                <el-dropdown @command="dropSel"   size="small" style="margin-left:15px;">
                    <el-button type="danger" size="small" style="height:31px">
                        更多<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown"  >
                        <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">导出数据</el-dropdown-item>
                        <el-dropdown-item icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">字段设置</el-dropdown-item>
                        <el-dropdown-item icon="iconfont icon-baocun" command="saveCond" style="line-height:40px;height:40px">保存查询条件</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-table  :data="tabData" 
              border                            
              size="small"
              header-cell-class-name="clearPadding"
              :header-cell-style="{ 'color':'#389','text-align':'center'}"
              :cell-style="{padding:'2px'}"
              :row-class-name="tabRowClass" 
              @row-click="rowClick"
              v-loading="v_loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 251, 255, 0.8)"
              @sort-change="sortChange"
              :height="subHeight" 
              :row-key="getRowKey"
              class="custom-table-border"
              show-summary
              :summary-method="getSummary"
              ref="reftab"
              highlight-current-row
              style="overflow:auto;margin-top:1px;"> 
            <el-table-column label="序号" type="index" width="60" fixed>
                <el-table-column label="序号" type="index" width="60" fixed>
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column   v-for="(item,index ) in tabCol.filter(item=>item.thide=='N').filter(item=>!setKeyCol.includes(item['key']))" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"  
                :fixed="item.fix=='Y'" 
                resizable                              
                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-select v-if="item.key=='GPNM'" @change="inputQry" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                            <span v-for="(item ,index) in gpArr" :key='index'>
                                <el-option :label="item.CNAME" :value="item.CNAME"  ></el-option>
                            </span>
                        </el-select>
                        <el-select v-else-if="item.key=='STFG'" @change="inputQry" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                            <el-option label="正常" value="Y"  ></el-option>
                            <el-option label="作废" value="N"  ></el-option>
                        </el-select>
                        <el-date-picker v-else-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                        <el-input type="number" placeholder="数字框"  @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark">正常</el-tag>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='N'" size="mini" type="info" effect="dark">作废</el-tag>                         
                        <el-link v-else-if="item.key=='imgpath' " :underline="false" > 
                            <el-image fit="scale-down"  style="width:80px;height:20px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                            </el-image>
                        </el-link>
                        <el-tag  v-else-if="item.key=='GPNM' " size="mini" type="info" effect="dark">{{scope.row[item.key]}}</el-tag>  
                        <span v-else v-text="scope.row[item.key]" ></span>
                    </template>
                </el-table-column>               
            </el-table-column> 
            <el-table-column
                fixed="right"
                label="状态操作"
                align="center"
                width="170">
                <template slot-scope="scope">
                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                    <el-link  @click="editRec(scope.row,'Y',scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">查看</span></el-link>           
                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                    <el-link :disabled="editBool"  @click="editRec(scope.row,'N',scope.$index)" :underline="false" style="font-size:12px;margin-right:5px; "><span style="font-size:12px;margin-right:5px">编辑</span></el-link> 
                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                    <el-link :disabled="delBool" @click="delRec(scope.row, scope.$index )" :underline="false" style="font-size:12px; "><span style="font-size:12px;">删除</span></el-link> 
 
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页查询 -->
        <div style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
  
        <!-- 提示框 -->
        <el-dialog :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
            </div>
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- 字段设置 -->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="setWin" width="400px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">字段显示设置</span>
            </div> 
            <div style="height:80vh;overflow-y:auto;">
                <div style="line-height:30px;height:30px" v-for="(item,index) in fldArr" :key="index">
                    <el-checkbox :disabled="item.CODE=='ordno'" true-label="Y" false-label="N" v-model="item['VISFLAG']" >{{item['CNAME']}}</el-checkbox>
                </div>
            </div>
            <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:2px; ">
                <span style="float:right">
                    <el-button type="info" @click="setWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button   @click="setOk" size="small" type="primary" style="margin-left:50px;" icon="iconfont icon-baocun"  > 保存设置 </el-button> 
                </span>
            </div>  
        </el-dialog> 
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <!-- <div style="height:88vh;overflow-y:auto"> -->
                <Form :model="formRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in tabCol" :key="index" >
                        <FormItem   :label="item.title"  :class=" item.edcss=='textarea'?'item-one':'item-width'" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="small" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="formRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input  size="small" :disabled="saveFlag" readonly  v-else-if="item.edcss=='button'" placeholder="请选择" v-model="formRow[item.key]" style="width:100%; "> 
                                <template slot="prefix" > <el-link @click="inputClear( item.key)" :underline="false" style="margin-top:3px" ><i class="iconfont icon-shanchu1" ></i></el-link></template>
                                <template slot="suffix" > <el-link @click="inputBtn( item.key)" :underline="false" style="margin-top:3px" ><i class="iconfont icon-icon-choose" ></i></el-link></template>
                            </el-input>
                            <el-input type="number" :disabled="saveFlag||item.disabled==='Y'"  :precision="item.dotnum" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="small" v-model="formRow[item.key]" style="width:100%"> </el-input> 
                            <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="4"  placeholder="请输入内容" v-model="formRow[item.key]" maxlength="1000" show-word-limit ></el-input>
                            <el-select size="small" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="formRow[item.key]"  filterable clearable style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input size="small" :placeholder="item.holder" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="formRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
            <!-- </div> -->
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button :disabled="saveFlag"  type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_random="v_random" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="50px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-image src="assets/authorize/loading.gif" fit="fill" style="height:30px;background:#F96161" ></el-image>
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate,getDate2} from '../../api/Select' 
import pubWin from '../datamgt/pubmulti.vue'  
import repWin from '../datamgt/repWin.vue' 
 
export default {
    name:'paychk_glps',
    data () {
        return {
            v_row:{},
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            toolFlag:false,
            qryCond:'',
            txtArr1:[],
            ruleValidate:{},
            v_bool:true,
            v_bool2:true,
            txtArr2:[],
            v_commit :true,
            promptWin:false,
            formRow:{},
            comboArr:[],
            btnWin:false,
            prompt:'',
            input_hold:'请输入内容...',
         
            selparam:'IDNO',
            txtparam:'',
    
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            tabData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            appBool:false, //作废权限
            delBool:false,
            v_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            v_clntno:'',
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            pageList: [{
                value: 100,
                label: '100'
                }, {
                value: 400,
                label: '400'
            }],
            selparam2:'',
            txtparam2:'',
            oper2:'like',
            dataCount:0,
            rowSize:100,
 
            tabCol:[],
            operArr:[],
            stkCol:[],
            poCol:[],
 
            oper:'like',
            v_key:'',
            v_idseq:this.$cookies.get('idseq'),
            dtlIndex:'',
            initCol:[],
            gpArr:[],
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            repWin:false,
            repUrl:'',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_random:'',
            fldArr:[],
            loadWin:false,
            fileName:'',
            uploadUrl:'xuper_auth/uploadImg' ,
            Accept: "png,jpg,jpeg,gif,tiff,pdf",
            delImg:[],
            v_admin:this.$cookies.get('v_admin') ,
            setCol:[],
            setKeyCol:[],
            notNull:[],
            setWin:false, 
            v_path:'',
        }
    },
    components: {
      pubWin,  
      repWin,
 
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 155) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 660) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
    },
    mounted () {
        getBaseData(this.v_url+ '','parentno','427695','','','v_sys_base','').then(res=>{
            this.gpArr =res.result
        })
        this.comSelect()
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        }) 
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username ,'frmidseq','427913','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ //作废
                    this.appBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','427913','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.initData() //询价单主数据   
            this.v_path =this.$route.path
            this.showkey()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        //刷新计算余额
        freshCalc(){
            this.$confirm('你确定要重新计算余额吗?' ,'提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.loadWin=true
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/call_procedure',
                    data: {corpid:this.v_corpid,p_user:this.v_username,p_action:'CALC_GLPS' },
                }).then(res=>{ 
                    if (res.code==='200'){
                        this.loadWin=false
                        this.getTabList('')
 
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                        this.loadWin=false
                    }
                })
                // setInterval(()=>{this.loadWin=false},5000)
            }).catch(()=>{})
        },
        // 确认选择
        btnSure(obj){
            let v_val =''
            obj.forEach(item =>{
                if (v_val){
                    v_val =v_val+',' +item['IDNO']
                }else{
                    v_val =item['IDNO']
                }
            })
            if (this.v_key =='STKOUTNO') {
                Object.assign(this.formRow, { STKOUTNO:v_val } )
            }else if (this.v_key =='PONO') {
                Object.assign(this.formRow, { PONO:v_val } )
            }
            this.btnWin =false
        }, 
        inputClear(key){
            if (key =='STKOUTNO') {
                this.formRow['STKOUTNO']=''
                this.$forceUpdate()
            }else if (key =='PONO') {
                this.formRow['PONO']=''
                this.$forceUpdate()
            }
        },
        inputBtn( key){   
            this.v_key =key   
            if (key =='STKOUTNO'){
                this.v_random='r'+Math.random() 
                this.v_table ='v_IC_STK'
                this.tableCol =this.stkCol
                this.v_key2 ='idty'
                this.v_value2 = 'SALEOUT'
            }else if (key =='PONO'){
                this.v_random='r'+Math.random() 
                this.v_table ='v_po_ord'
                this.tableCol =this.poCol
                this.v_key2 ='poty'
                this.v_value2 = 'PRD'
            }
            this.btnWin =true
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: this.v_url+'',
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'427913',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData(this.v_url,'parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.formRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) { 
                this.v_commit =false
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.formRow,{CORPID:this.v_corpid })), p_table:'PAY_GSCHK',frmid:'427913'},
                }).then(res=>{      
                    if(res.code ==='200')  {  
                        let idseq_ =res.idseq
                        this.addWin =false   
                        this.inputQry()
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
 
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.formRow={ STFG:'N',DTTM:getDate('day') }
            
            this.saveFlag=false
            this.v_commit =true
        },
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                this.saveFlag=false
            }
            this.formRow =JSON.parse(JSON.stringify(row ))
            this.addWin=true   
            this.v_commit =true   
        },
        //删除记录
        delRec(row,index){
            this.$confirm('你确定要删除此记录吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'],  p_table:'PAY_GSCHK' },
                }).then(res=>{
                    this.tabData.splice(index,1)
                })
            }).catch(err =>{})
        } ,

        rowClick(row){
 
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
 
                const values =this.allList.map(item=>Number(item[column.property]));
                if( column.property==='SALEAMT'||column.property==='RTNAMT' ){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
 
        imgPreview(path){
           
            window.open(path, '_blank');
        },
        //用户界面字段列表
        getSetList(){
            getTabColOrData(this.v_url,'V_FORM_FLDSET','idseq','427913','userno',this.v_username).then((res) => {
                this.setCol =res.result
                this.setKeyCol =[]
                res.result.forEach(item=>{
                    if (item['VISFLAG'] =='N') {
                        this.setKeyCol.push(item['FLDNO'])
                    }
                }) 
            })
        }, 
        //字段设置保存
        setOk(){  
            for(var k=0;k<this.fldArr.length;k++){
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/tableBodySave',
                    data: {p_json:JSON.stringify(Object.assign(this.fldArr[k] )), p_table:'form_fldset',p_idseq:''},
                }).then(res =>{
                    this.getSetList()
                })
            }
            this.setWin =false
        },
        //split-button 下拉选项
        dropSel(val){
            if (val =='expdata'){ //导出数据
                //导出
                let cond_=[]  ,v_edcss ='',v_edcss2=''
                if (this.selparam) {
                    this.tabCol.some(item=>{
                        if (item['key']==this.selparam){
                            v_edcss =item['edcss']
                        }
                    })
                    if (v_edcss=='date' && this.txtArr1 ){
                        cond_.push(this.selparam)
                        cond_.push('range')
                        cond_.push('  >= \''+this.txtArr1[0]+'\' and '+this.selparam+'<=\''+this.txtArr1[1]+'\' ') 
                    }else{
                        cond_.push(this.selparam)
                        cond_.push(this.oper)
                        cond_.push(this.txtparam)
                    }
                }
                 if (this.selparam2){ //列1
                    this.tabCol.some(item=>{
                        if (item['key']==this.selparam2){
                            v_edcss2 =item['edcss']
                        }
                    })
                    if (v_edcss2 =='date'){
                        if (this.txtArr2 )
                        cond_=cond_+' and '+this.selparam2+' between \'' + this.txtArr2[0]+'\' and \''+ this.txtArr2[1]+'\''
                    }else {
                        if (this.oper2==='like'){
                            cond_=cond_+' and '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                        }else{
                            if (this.txtparam2){
                                if (v_edcss2=='number'){
                                    cond_=cond_+' and  '+this.selparam2  +this.oper2+ this.txtparam2
                                }else {
                                    cond_=cond_+' and '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                                }
                            }
                        }
                    }
                }
                let url='xuper_auth/report/ExpExcel'+'&p_idseq=427913&p_lstseq=1&p_table=V_PAY_GSCHK&p_cond='+cond_+'&p_filenm=歌蕾佩斯应付对账'
                window.open(url)
            }else if (val=='saveCond'){
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: { p_key:'corpid', p_value:this.v_corpid,p_key2:'PATH',p_value2:this.v_path,p_cond:' and userno=\''+this.v_username+'\'',p_table:'V_QRY_COND'},
                }).then(res=>{ 
                    if (res.result.length==0){
                        let v_obj={IDSEQ:'',CORPID:this.v_corpid,PATH:this.v_path,USERNO:this.v_username,SELPARAM:this.selparam,OPER:this.oper,
                            TXTPARAM:this.txtparam,SELPARAM2:this.selparam2,OPER2:this.oper2,TXTPARAM2:this.txtparam2,STFG:this.stfg_}
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/formOneSave',
                            data: {p_json:JSON.stringify(v_obj), p_table:'QRY_COND',frmid:''},
                        }).then(res=>{
                            this.$notify({title: '成功', message: '已成功保存查询条件', type: 'success' })       
                        })
                    }else{ //更新
                        let v_sel='',v_text='',v_sel2='',v_text2=''
                        if (this.selparam){
                            v_sel =this.selparam
                        }
                        if (this.txtparam){
                            v_text =this.txtparam
                        }
                        if (this.selparam2){
                            v_sel2 =this.selparam2
                        }
                        if (this.txtparam2){
                            v_text2 =this.txtparam2
                        }
                        let v_cond=' set selparam=\''+v_sel+'\',oper=\''+this.oper+'\',txtparam=\''+v_text+'\',stfg=\''+this.stfg_+'\',selparam2=\''+v_sel2+'\',oper2=\''+this.oper2+'\',txtparam2=\''+v_text2+'\''
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:res.result[0]['IDSEQ'],p_table:'QRY_COND',p_cond: v_cond},
                        }).then(res=>{ 
                            this.$notify({title: '成功', message: '已成功保存查询条件', type: 'success' })       
                        })
                    }
                })
 
            }else if (val =='fldset'){  //字段设置显示--隐藏
                this.fldArr =[]
                this.initCol.filter(item=>item.THIDE=='N').forEach(item =>{
                    if (this.setCol.length>0) {
                        let v_row = ''
                        this.setCol.some(it =>{
                            if (it['FLDNO'] ==item['FLDNO'] ) {
                                v_row =it
                            }
                        })
                        if (v_row ){
                            let v_obj ={'IDSEQ':'427913','LSTSEQ':v_row['LSTSEQ'],CORPID:this.v_corpid,USERNO:this.v_username,CODE:item['FLDNO'],CNAME:item['FLDNM'],REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ'],REFITMSEQ:item['ITMSEQ'],'VISFLAG':v_row['VISFLAG']}
                            this.fldArr.push(v_obj)
                        }else {   
                            let v_obj ={'IDSEQ':'427913','LSTSEQ':'',CORPID:this.v_corpid,USERNO:this.v_username,CODE:item['FLDNO'],CNAME:item['FLDNM'],REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ'],REFITMSEQ:item['ITMSEQ'],'VISFLAG':'Y'}
                            this.fldArr.push(v_obj)
                        }          
                    }else{
                        let v_obj ={'IDSEQ':'427913',LSTSEQ:'',CORPID:this.v_corpid,USERNO:this.v_username,CODE:item['FLDNO'],CNAME:item['FLDNM'],REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ'],REFITMSEQ:item['ITMSEQ'],'VISFLAG':'Y'}
                        this.fldArr.push(v_obj)
                    }
                })
                this.setWin =true               
            }
        },
        fldSort(key,val,type){
            if (type=='number'){
                // 按 value 属性升序排序
                this.allList.sort(function (a, b) {
                    if (val=='ascending'){
                        return a[key] - b[key]
                    }else{
                        return b[key] - a[key]
                    }
                })
            }else{
                this.allList.sort(function (a, b) {
                    let nameA = a[key].toUpperCase() // 转换为大写字母以处理大小写
                    let nameB = b[key].toUpperCase()
                    if (nameA < nameB) {
                        if (val=='ascending'){
                            return -1
                        }else{
                            return 1
                        }
                    }
                    if (nameA > nameB) {
                        if (val=='ascending'){
                            return 1
                        }else{
                            return -1
                        }
                    }
                })
            }
            this.initPage()
        },
        sortChange(column,prop,order){
            let v_key =column['prop'] ,v_edcss=''
            let v_sort =column['order']  //descending  ascending
            this.tabCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.fldSort(v_key,v_sort,v_edcss)
            //console.log(column['order'],column['prop'] )
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        selChg(val){
            this.tabCol.some(it=>{
                if (it['key']== val){
                    if (it['edcss']=='date'){
                        this.v_bool =false
                    }else{
                        this.v_bool =true
                    }
                }
            })
            this.txtArr1=[]
            this.txtparam1=''
        },
        selChg2(val){
            this.tabCol.some(it=>{
                if (it['key']== val){
                    if (it['edcss']=='date'){
                        this.v_bool2 =false
                    }else{
                        this.v_bool2 =true
                    }
                }
            })
            this.txtArr2=[]
            this.txtparam2=''
        },
        //字段查询
        inputQry(){
            let cond_='' ,v_edcss='',v_edcss2=''
            if (this.selparam){ //列1
                this.tabCol.some(item=>{
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (v_edcss =='date'){
                    if (this.txtArr1 )
                    cond_=cond_+' and '+this.selparam+' between \'' + this.txtArr1[0]+'\' and \''+ this.txtArr1[1]+'\''
                }else {
                    if (this.oper==='like'){
                        cond_=cond_+' and  '+this.selparam+' like  \'%' + this.txtparam+'%\' '
                    }else{
                        if (this.txtparam){
                            if (v_edcss=='number'){
                                cond_=cond_+' and  '+this.selparam  +this.oper+ this.txtparam
                            }else {
                                cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                            }
                        }
                    }
                }
            }
            if (this.selparam2){ //列1
                this.tabCol.some(item=>{
                    if (item['key']==this.selparam2){
                        v_edcss2 =item['edcss']
                    }
                })
                if (v_edcss2 =='date'){
                    if (this.txtArr2 )
                    cond_=cond_+' and '+this.selparam2+' between \'' + this.txtArr2[0]+'\' and \''+ this.txtArr2[1]+'\''
                }else {
                    if (this.oper2==='like'){
                        cond_=cond_+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                    }else{
                        if (this.txtparam2){
                            if (v_edcss2=='number'){
                                cond_=cond_+' and  '+this.selparam2  +this.oper2+ this.txtparam2
                            }else {
                                cond_=cond_+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                            }
                        }
                    }
                }
            }
            let v_cond =''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            this.getTabList(cond_+v_cond)
        },
 
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.getTabList('')
        } ,
 
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
 
 
        getRowKey(row){
            return row.index
        },
   
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
 
        },
        //初始化
        initData(){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid,p_key2:'PATH',p_value2:this.$route.path,p_cond:' and userno=\''+this.v_username+'\'',p_table:'V_QRY_COND'},
            }).then(res=>{ 
                let v_row =res.result
                if (v_row.length==0){
                   this.inputQry() 
                }else{
                    let v_sel='',v_text='',v_sel2='',v_text2=''
                    if (v_row[0]['SELPARAM']){
                        v_sel =v_row[0]['SELPARAM']
                    }
                    if (v_row[0]['TXTPARAM']){
                        v_text =v_row[0]['TXTPARAM']
                    }
                    if (v_row[0]['SELPARAM2']){
                        v_sel2 =v_row[0]['SELPARAM2']
                    }
                    if (v_row[0]['TXTPARAM2']){
                        v_text2 =v_row[0]['TXTPARAM2']
                    }
                    this.selparam =v_sel
                    this.oper =v_row[0]['OPER']
                    this.txtparam =v_text
                    this.selparam2 =v_sel2
                    this.oper2 =v_row[0]['OPER2']
                    this.txtparam2 =v_text2
                    this.stfg_ =v_row[0]['STFG']
                    this.inputQry()
                }
            })
        },
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.tabData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.tabData = this.allList          
            }else{
         
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.tabData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
 
        },
        //查询界面
        getTabList(cond){    
            this.v_loading=true
            getTabColOrData(this.v_url,'V_PAY_GSCHK','','','corpid',this.v_corpid,'','',cond +' order by dttm,adddttm').then((res) => { 
                if (res.code=='200'){
                    this.allList =res.result 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.v_loading=false
                        if (this.allList.length>0){
                            this.$refs['reftab'].setCurrentRow(this.allList[0])
                        }
                        this.$refs['reftab'].doLayout()
                    }) 
                    this.initPage() 
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            this.getSetList()
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','427913','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    this.initCol =res.result
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        holder:res.result[k].HOLDER,
                        sortable:res.result[k].SORTABLE,
                        fix:res.result[k].ISFIX,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','124','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.stkCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        sortable:res.result[k].SORTABLE, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','108','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.poCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                        dotnum:res.result[k].DOTNUM,
                    })                  
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        height:20px;
        width: 32%;
    }
    .item-one {
        width: 97%;
        height:88px;
    }
    .custom-button {
      background: rgb(107, 104, 104);
      font-weight:600;
      font-size:14px;
      color:#cc0000 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .custom-button:hover {
     // background: rgb(107, 104, 104);//rgb(248, 230, 230) !important;
      font-weight:600;
      font-size:14px;
      color:#389 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-range-separator {
        width: 20px !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple; 
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .default-row {
        color:black;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-table .green-row  {
        color: green;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>